<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div v-if="isEditingEmployee" class="rounded border p-4 bg-white mb-2">
      <div class="p-2">
        <h3>Edit Employee</h3>
      </div>
      <div>
        <div class="row">
          <CustomFormField label="Name">
            <b-form-input v-model="selectedEmployee.emp_name" class="form-control px-3 bg-gray-200" disabled
                          placeholder="Enter name"
                          style="height: 44px;"/>
          </CustomFormField>
          <CustomFormField label="Bangla Name">
            <b-form-input v-model="selectedEmployee.emp_name_bng" class="form-control px-3 bg-gray-200" disabled
                          placeholder="Enter bangla name"
                          style="height: 44px;"/>
          </CustomFormField>
          <CustomFormField label="Email">
            <b-form-input v-model="selectedEmployee.emp_primary_email" class="form-control px-3 bg-gray-200" disabled
                          placeholder="Enter email"
                          style="height: 44px;"/>
          </CustomFormField>
          <CustomFormField label="Phone">
            <b-form-input v-model="selectedEmployee.emp_primary_mobile" class="form-control px-3 bg-gray-200" disabled
                          placeholder="Enter phone"
                          style="height: 44px;"/>
          </CustomFormField>
          <CustomFormField label="Designation">
            <b-form-input v-model="selectedEmployee.designation" class="form-control px-3 bg-gray-200"
                          disabled placeholder="Enter designation" style="height: 44px;"/>
          </CustomFormField>

          <CustomFormField label="Weight">
            <b-form-input v-model="selectedEmployee.serial_no" class="form-control px-3"
                          placeholder="Enter weight"
                          style="height: 44px;"
                          type="number"/>
          </CustomFormField>

          <CustomFormField label="Office Address">
            <b-form-input v-model="selectedEmployee.office_address" class="form-control px-3"
                          placeholder="Enter address"
                          style="height: 44px;"/>
          </CustomFormField>
          <CustomFormField label="Office Address Bangla">
            <b-form-input v-model="selectedEmployee.office_address_bng" class="form-control px-3"
                          placeholder="Enter address"
                          style="height: 44px;"/>
          </CustomFormField>
          <CustomFormField label="Office Phone">
            <b-form-input v-model="selectedEmployee.office_phone" class="form-control px-3"
                          placeholder="Enter office phone"
                          style="height: 44px;"/>
          </CustomFormField>
          <CustomFormField label="Intercom">
            <b-form-input v-model="selectedEmployee.intercom" class="form-control px-3"
                          placeholder="Enter intercom number"
                          style="height: 44px;"/>
          </CustomFormField>
          <CustomFormField label="Fax">
            <b-form-input v-model="selectedEmployee.fax" class="form-control px-3" placeholder="Enter fax"
              style="height: 44px;" />
          </CustomFormField>
          <CustomFormField label="Is Authority">
            <b-form-select v-model="selectedEmployee.authority" :options="[
              { value: 'Y', text: 'Yes' },
              { value: 'N', text: 'No' }
            ]" class="form-control px-3" style="height: 44px;" />
          </CustomFormField>

        </div>
      </div>
      <div class="mt-2">
        <button class="btn btn-primary px-4 py-2 mr-2" @click="updateEmployeeInfo">
          Update
        </button>
        <button class="btn btn-danger px-4 py-2" @click="cancelUpdating">Cancel</button>
      </div>
    </div>


    <div class="rounded border p-4 bg-white">
      <div class="p-2">
        <div class="d-flex flex-row">
          <h3>All Employees</h3>
          <button class="ms-3 rounded btn-primary me-4" @click="updateEmployeeList">Update Employee List</button>
           <button
            :class="updateEmpPhotoBtnDisabled ? 'ms-3 rounded btn-secondary me-4' : 'ms-3 rounded btn-primary me-4'"
            :disabled="updateEmpPhotoBtnDisabled"     
            @click="updateAllEmployeePhoto"
          >
            Update All Employee Photo
          </button>
        </div>
        <!-- page size  -->
        <div class="my-4 d-flex flex-wrap gap-2">
          <div style="width: 170px">
            <!--            <b-form-select v-model="perPage" :options="pageOptions"-->
            <!--                           size="sm"></b-form-select>-->
            <select v-model="perPage" class="py-2 border rounded px-2">
              <option v-for="(info, index) in pageOptions" :key="index" :value="info" style="max-width: 100%">
                {{ info }}
              </option>
            </select>
          </div>
          <select v-model="selectedDivision" class="py-2 border rounded px-2" style="max-width: 100%"
                  @change="filterByDivision">
            <option :value=null>All Divisions</option>
            <option v-for="(info, index) in divisionList" :key="index" :value="info" style="max-width: 100%">
              {{ info }}
            </option>
          </select>

          <!-- search  -->
          <div class="d-flex flex-row flex-grow-1">
            <!--            -->
            <!--            @click="onSearch"-->
            <b-form-input v-model="filter" :formatter="searchFormatter" class="me-2 d-flex flex-grow-1"
                          placeholder="Type to filter data" type="search"></b-form-input>
            <button class="rounded btn-info" @click="searchFormatter(filter)">Search</button>
          </div>
        </div>
        <b-table :busy="loading" :current-page="currentPage" :fields="fields" :items="employeeList" :per-page="perPage"
                 bordered hover
                 responsive striped>
          <template #cell(actions)="row">
            <div class="d-flex flex-row gap-1 justify-content-center">
              <button class="btn btn-info btn-sm" title="Edit Employee" type="button" @click="startEditing(row.item)">
                <i class="fa-regular fa-pen-to-square"></i>
              </button>
              <button class="btn btn-warning btn-sm" title="Refresh Employee Info from ERP" type="button"
                      @click="refreshEmployeeInfo(row.item)">
                <i class="fa-solid fa-rotate"></i>
              </button>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2 px-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
        <!-- Pagination -->
        <b-row>
          <b-col class="mt-2" md="12" sm="12">
            <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                          align="center" class="my-0" next-text="Next" prev-text="Prev">
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import AllUsersService from "@/services/all-users.service";
import CustomFormField from "@/components/CustomFormField.vue";
import {notify} from "@kyvg/vue3-notification";

export default {
  setup() {
  },
  components: {
    CustomFormField
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Employee Info',
          href: '#'
        }
      ],
      fields: [
        {
          label: 'Name', key: 'emp_name', sortable: true,
          tdClass: "px-3", thClass: "px-3", thStyle: {width: "20%"},
        },
        {
          label: 'Gender', key: 'emp_gender_name', sortable: true,
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Phone', key: 'emp_primary_mobile', sortable: true,
          tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'designation', sortable: true, thStyle: {width: "20%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Division', key: 'employee_division_name', sortable: true, thStyle: {width: "30%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Department', key: 'employee_department_name', sortable: true, thStyle: {width: "30%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Weight', key: 'serial_no', sortable: true, thStyle: {width: "5%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {key: 'actions', label: 'Actions', class: 'text-center', thStyle: {width: "10%"},},
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 100],
      filter: null,
      loading: false,
      updateEmpPhotoBtnDisabled: false,
      employeeList: [],
      backupEmployeeList: [],
      departmentList: [],
      divisionList: [],
      selectedDepartment: null,
      selectedDivision: null,
      selectedEmployee: null,
      isEditingEmployee: false
    };
  },
  async created() {
    await this.fetchEmployees();
  },
  methods: {
    searchFormatter(data) {
      if (data != null && data !== "") {
        this.employeeList = [...this.backupEmployeeList.filter(emp => emp.emp_name.toLowerCase().includes(data.toLowerCase()))]
      } else {
        this.employeeList = [...this.backupEmployeeList];
      }
      this.totalRows = this.employeeList.length;
      this.currentPage = 1;
      return data;
    },

    filterByDepartment() {
      if (this.selectedDepartment && this.selectedDepartment !== '') {
        this.employeeList = [...this.backupEmployeeList.filter(emp => emp.employee_department_name === this.selectedDepartment)]
      } else {
        this.employeeList = [...this.backupEmployeeList]
      }
      this.totalRows = this.employeeList.length;
    },

    filterByDivision() {
      if (this.selectedDivision && this.selectedDivision !== '') {
        this.employeeList = [...this.backupEmployeeList.filter(emp => emp.employee_division_name === this.selectedDivision)]
      } else {
        this.employeeList = [...this.backupEmployeeList]
      }
      this.totalRows = this.employeeList.length;
    },

    cancelUpdating() {
      this.selectedEmployee = null
      this.isEditingEmployee = false
    },
    async updateEmployeeList() {
      try {
        this.loading = true;
        const response = await AllUsersService.updateEmployeeList()
        this.loading = false;
        if (response.data && response.data.status) {
          notify({
            type: "success",
            title: "Successful",
            text: response.data.message,
          });
          await this.fetchEmployees();
        } else {
          notify({
            type: "error",
            title: "Unsuccessful",
            text: response.data.message,
          });
        }
      } catch (e) {
        console.log(e)
      }
    },
     async updateAllEmployeePhoto() {
      try {
        this.loading = true;
        this.updateEmpPhotoBtnDisabled = true;
        console.log("updateAllEmployeePhoto_Clicked")
        const response = await AllUsersService.updateAllEmployeePhoto()
        console.log("updateAllEmployeePhoto",response)
        this.loading = false;
        this.updateEmpPhotoBtnDisabled = false;
        if (response.data && response.data.status) {
          notify({
            type: "success",
            title: "Successful",
            text: response.data.message,
          });
          await this.fetchEmployees();
        } else {
          notify({
            type: "error",
            title: "Unsuccessful",
            text: response.data.message,
          });
        }
      } catch (e) {
        console.log(e)
      }
    },
    async startEditing(employeeData) {
      try {
        console.log('employeeData', employeeData)
        this.loading = true;
        const response = await AllUsersService.getSingleEmployee({emp_code: employeeData.emp_code})
        if (response.data && response.data.emp_name) {
          window.scrollTo(0, 0);
          this.selectedEmployee = response.data
        }
        this.loading = false;
        // this.selectedEmployee = employeeData
        this.isEditingEmployee = true
      } catch (e) {
        this.loading = false;
        console.log(e)
      }
    },

    async refreshEmployeeInfo(employeeData) {
      try {
        this.loading = true;
        const response = await AllUsersService.refreshSingleEmployee({emp_code: employeeData.emp_code})
        if (response.data && response.data.status) {
          notify({
            type: "success",
            title: "Successful",
            text: response.data.message,
          });
        } else {
          notify({
            type: "error",
            title: "Error",
            text: response.data.message,
          });
        }
        this.loading = false;
      } catch (e) {
        console.log(e)
        this.loading = false;
      }

    },
    async updateEmployeeInfo() {
      try {
        this.loading = true;
        const response = await AllUsersService.updateInternalUser(this.selectedEmployee);
        this.loading = false;
        if (response.data.status) {
          notify({
            type: "success",
            title: "Successful",
            text: response.data.message,
          });
          this.cancelUpdating()
          await this.fetchEmployees()
        } else {
          notify({
            type: "error",
            title: "Unsuccessful",
            text: response.data.message,
          });
        }
      } catch (e) {
        this.loading = false;
      }
    },
    async fetchEmployees() {
      try {
        this.loading = true;
        const response = await AllUsersService.getAllEmployee();
        this.loading = false;
        if (response.data && response.data.length > 0) {
          this.currentPage = 1
          this.backupEmployeeList = response.data
          if (this.selectedDivision && this.selectedDivision !== '') {
            this.employeeList = [...this.backupEmployeeList.filter(emp => emp.employee_division_name === this.selectedDivision)]
          } else {
            this.employeeList = response.data
          }
          this.totalRows = this.employeeList.length;
          this.departmentList = [...new Set(this.employeeList.map(emp => emp.employee_department_name))]
          this.divisionList = [...new Set(this.employeeList.map(emp => emp.employee_division_name))]
        }
      } catch (e) {
        this.loading = false;
      }
    }
  }

};
</script>

<style>
</style>
